import React, { useEffect, useState, useRef } from "react";
import { Table, Button, Modal, Form, Alert, Container, Row, Col, Card, Badge } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaSearch, FaCog, FaBuilding, FaUtensils } from "react-icons/fa";
import { Modal as AntModal } from "antd";
import { useTipoServiciosComedor } from '../../../services/hooks/useTipoServiciosComedor';
import { useProyectos } from '../../../services/hooks/useProyectos';
import { useClientes } from '../../../services/hooks/useClientes';
import { useProyectoCliente } from '../../../services/hooks/useProyectoCliente';
import { useComedores } from '../../../services/hooks/useComedores';
import { useTipoServiciosAlimentacion } from '../../../services/hooks/useTipoServiciosAlimentacion';

const GestionTipoServiciosComedor = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  
  // Obtener proyecto seleccionado de la sesión
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
  
  // Usar los hooks para las diferentes entidades
  const { 
    tipoServiciosComedor, 
    loading: loadingTiposServicio,
    fetchTipoServiciosComedor, 
    fetchTipoServiciosComedorByProyecto,
    createTipoServicioComedor, 
    updateTipoServicioComedor, 
    deleteTipoServicioComedor 
  } = useTipoServiciosComedor();
  const { 
    proyectosAsignados: clientesDelProyecto, 
    fetchClientesByProyecto,
    loading: loadingClientes 
  } = useProyectoCliente();
  const { comedores, fetchComedoresByProyecto } = useComedores();
  const { tipoServiciosAlimentacion, fetchTipoServiciosAlimentacion } = useTipoServiciosAlimentacion();
  
  const [state, setState] = useState({
    searchTerm: "",
    registroSeleccionado: null
  });
  const [showModal, setShowModal] = useState(false);
  const [editRegistro, setEditRegistro] = useState(null);
  const [form, setForm] = useState({
    id_proyecto: "",
    id_cliente: "",
    id_comedor: "",
    id_tipo_servicio_alimentacion: "",
    precio: "",
    numero_orden: "99",
  });
  const [error, setError] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [registroToDelete, setRegistroToDelete] = useState(null);
  const hasFetched = useRef(false);

  // Cargar datos iniciales
  useEffect(() => {
    const loadInitialData = async () => {
      if (!hasFetched.current && selectedProject?.id) {
        try {
          await fetchTipoServiciosComedorByProyecto(selectedProject.id);
          hasFetched.current = true;
        } catch (error) {
          console.error("Error al cargar datos iniciales:", error);
          toast.error("Error al cargar datos iniciales", {
            position: "bottom-right",
            autoClose: 2000
          });
        }
      }
    };

    loadInitialData();
  }, [fetchTipoServiciosComedorByProyecto, selectedProject]);

  const handleSearch = (event) => {
    setState(prev => ({ ...prev, searchTerm: event.target.value }));
  };

  const handleRegistroSelect = (registro) => {
    setState(prev => ({ 
      ...prev, 
      registroSeleccionado: prev.registroSeleccionado?.id === registro.id ? null : registro 
    }));
  };

  const handleShowModal = async (registro = null) => {
    setEditRegistro(registro);
    setForm(
      registro
        ? {
            id_proyecto: registro.id_proyecto,
            id_cliente: registro.id_cliente,
            id_comedor: registro.id_comedor,
            id_tipo_servicio_alimentacion: registro.id_tipo_servicio_alimentacion,
            precio: registro.precio,
            numero_orden:
              registro.numero_orden !== undefined && registro.numero_orden !== null
                ? String(registro.numero_orden)
                : "99",
          }
        : {
            id_proyecto: selectedProject?.id || "",
            id_cliente: "",
            id_comedor: "",
            id_tipo_servicio_alimentacion: "",
            precio: "",
            numero_orden: "99",
          }
    );
    setShowModal(true);
    setError("");
    await cargarDependenciasModal();
  };

  const cargarDependenciasModal = async () => {
    try {
      console.log('Cargando dependencias del modal...');
      console.log('Proyecto seleccionado:', selectedProject);
      
      // Cargar dependencias necesarias para el modal
      if (selectedProject?.id) {
        console.log('Cargando clientes para proyecto:', selectedProject.id);
        const clientesResult = await fetchClientesByProyecto(selectedProject.id);
        console.log('Clientes cargados:', clientesResult);
        
        console.log('Cargando comedores para proyecto:', selectedProject.id);
        const comedoresResult = await fetchComedoresByProyecto(selectedProject.id);
        console.log('Comedores cargados:', comedoresResult);
        
        console.log('Cargando tipos de servicios de alimentación...');
        const tiposResult = await fetchTipoServiciosAlimentacion();
        console.log('Tipos de servicios cargados:', tiposResult);
      } else {
        console.log('No hay proyecto seleccionado, solo cargando tipos de servicios...');
        await fetchTipoServiciosAlimentacion();
      }
      console.log('Dependencias cargadas exitosamente');
    } catch (error) {
      console.error("Error al cargar dependencias:", error);
      toast.error("Error al cargar las dependencias", {
        position: "bottom-right",
        autoClose: 2000
      });
    }
  };



  const handleCloseModal = () => {
    setShowModal(false);
    setEditRegistro(null);
    setForm({
      id_proyecto: "",
      id_cliente: "",
      id_comedor: "",
      id_tipo_servicio_alimentacion: "",
      precio: "",
      numero_orden: "99",
    });
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // El proyecto está fijo desde la sesión, solo permitir cambios en otros campos
    if (name !== "id_proyecto") {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSave = async () => {
    // Verificar que hay un proyecto seleccionado en la sesión
    if (!selectedProject || !selectedProject.id) {
      setError("No hay un proyecto seleccionado. Por favor, seleccione un proyecto primero.");
      return;
    }

    if (
      !form.id_proyecto ||
      !form.id_cliente ||
      !form.id_comedor ||
      !form.id_tipo_servicio_alimentacion ||
      !form.precio ||
      form.numero_orden === "" ||
      form.numero_orden === null ||
      form.numero_orden === undefined
    ) {
      setError("Todos los campos son obligatorios");
      return;
    }

    const ordenNum = parseInt(form.numero_orden, 10);
    if (Number.isNaN(ordenNum) || ordenNum < 0) {
      setError("El número de orden debe ser un entero mayor o igual a 0");
      return;
    }

    const payload = {
      ...form,
      numero_orden: ordenNum,
      precio: parseFloat(form.precio),
    };

    try {
      if (editRegistro) {
        await updateTipoServicioComedor(editRegistro.id, payload);
        toast.success("Registro actualizado con éxito", {
          position: "bottom-right",
          autoClose: 1000
        });
      } else {
        await createTipoServicioComedor(payload);
        toast.success("Registro creado con éxito", {
          position: "bottom-right",
          autoClose: 1000
        });
      }
      // Recargar datos después de guardar
      if (selectedProject?.id) {
        await fetchTipoServiciosComedorByProyecto(selectedProject.id);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error al guardar:", error);
      
      // Extraer mensaje específico del error del backend
      let errorMessage = "Error al guardar. Intente nuevamente.";
      
      if (error.response?.data?.error) {
        if (typeof error.response.data.error === 'string') {
          errorMessage = error.response.data.error;
        } else if (error.response.data.error.message) {
          errorMessage = error.response.data.error.message;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setError(errorMessage);
      toast.error(errorMessage, {
        position: "bottom-right",
        autoClose: 3000
      });
    }
  };

  const handleDelete = (id) => {
    if (!id) {
      toast.error("Por favor seleccione un registro para eliminar", {
        position: "bottom-right",
        autoClose: 2000
      });
      return;
    }

    setRegistroToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!registroToDelete) return;

    setShowDeleteModal(false);
    
    // Limpiar selección si es el elemento a eliminar
    if (state.registroSeleccionado?.id === registroToDelete) {
      setState(prev => ({ ...prev, registroSeleccionado: null }));
    }
    
    try {
      await deleteTipoServicioComedor(registroToDelete);
      toast.success("Registro eliminado con éxito", {
        position: "bottom-right",
        autoClose: 1000
      });
      // Recargar datos después de eliminar
      if (selectedProject?.id) {
        await fetchTipoServiciosComedorByProyecto(selectedProject.id);
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
      toast.error("Error al eliminar el registro", {
        position: "bottom-right",
        autoClose: 2000
      });
    } finally {
      setRegistroToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setRegistroToDelete(null);
  };

  // Filtrar registros usando directamente el array del hook
  const filteredRegistros = (Array.isArray(tipoServiciosComedor) ? tipoServiciosComedor : [])
    .filter((registro) => {
      const searchLower = state.searchTerm.toLowerCase();
      return (
        (registro.proyecto || '').toString().toLowerCase().includes(searchLower) ||
        (registro.cliente || '').toString().toLowerCase().includes(searchLower) ||
        (registro.comedor || '').toString().toLowerCase().includes(searchLower) ||
        (registro.tipo_servicio_alimentacion || '').toString().toLowerCase().includes(searchLower) ||
        (registro.precio || '').toString().toLowerCase().includes(searchLower) ||
        (registro.numero_orden ?? '').toString().toLowerCase().includes(searchLower)
      );
    })
    .slice()
    .sort((a, b) => {
      const oa = Number(a.numero_orden ?? 99);
      const ob = Number(b.numero_orden ?? 99);
      if (oa !== ob) return oa - ob;
      return (b.id || 0) - (a.id || 0);
    });

  return (
    <>
      {/* Digital Harmony Styles */}
      <style>
        {`
          /* Fondo degradado */
          .dh-maintenance-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          /* Header principal */
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-main-title {
            font-size: 2.2rem;
            font-weight: 700;
            margin: 0;
          }
          
          .dh-main-subtitle {
            font-size: 1.1rem;
            opacity: 0.9;
            margin: 0.5rem 0 0 0;
          }
          
          /* Cards con Digital Harmony */
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            margin-bottom: 2rem;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            font-weight: 700;
          }
          
          .dh-card-header-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }
          
          /* Botones Digital Harmony */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(251, 191, 36, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(251, 191, 36, 0.4);
            color: white;
          }
          
          .btn-dh-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-danger:hover {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          /* Campos de formulario modernos */
          .dh-form-control {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }
          
          /* Enhanced Table */
          .dh-enhanced-table {
            border-collapse: separate;
            border-spacing: 0;
            border-radius: 15px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            background: white;
          }
          
          .dh-enhanced-table thead th {
            background: #374151 !important;
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.875rem !important;
            text-transform: uppercase !important;
            padding: 1rem 0.75rem !important;
            border: none !important;
            position: sticky !important;
            top: 0 !important;
            z-index: 10 !important;
          }
          
          .dh-enhanced-table tbody td {
            padding: 0.75rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.9rem;
            vertical-align: middle;
          }
          
          .dh-enhanced-table tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(102, 126, 234, 0.02) 100%) !important;
          }
          
          .dh-enhanced-table tbody tr.selected {
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%) !important;
            border-left: 4px solid #667eea;
          }
          
          /* Badge moderno */
          .dh-badge {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 10px;
            padding: 8px 12px;
            font-weight: 600;
            font-size: 0.85rem;
          }
          
          /* Loading spinner personalizado */
          .dh-spinner {
            display: inline-block;
            width: 2rem;
            height: 2rem;
            border: 0.25rem solid rgba(102, 126, 234, 0.2);
            border-radius: 50%;
            border-top-color: #667eea;
            animation: spin 1s ease-in-out infinite;
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          /* Alert personalizado */
          .dh-alert {
            border-radius: 15px;
            padding: 1rem 1.5rem;
            border: none;
            margin-bottom: 1.5rem;
          }
          
          .dh-alert-info {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 197, 253, 0.1) 100%);
            color: #1e40af;
            border-left: 4px solid #3b82f6;
          }
          
          .dh-alert-warning {
            background: linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(251, 191, 36, 0.1) 100%);
            color: #92400e;
            border-left: 4px solid #f59e0b;
          }
        `}
      </style>

      <div className="dh-maintenance-bg">
        <ToastContainer />
        
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="dh-main-title">
                  <FaBuilding className="me-3" />
                  Mantenimiento Tipo Servicios Comedor
                </h1>
                <p className="dh-main-subtitle">Gestión de servicios de comedores por proyecto</p>
              </div>
              <div className="d-flex align-items-center gap-3">
                <Badge className="dh-badge">
                  Proyecto: {selectedProject?.nombre || "No seleccionado"}
                </Badge>
                <Button 
                  className="btn-dh-secondary d-flex align-items-center"
                  onClick={() => navigate("/home")}
                >
                  <FaArrowLeft className="me-2" />
                  Volver
                </Button>
              </div>
            </div>
          </Container>
        </div>

        <Container fluid className="py-4">
          <Row>
            <Col lg={12}>
              {/* Verificar que hay proyecto seleccionado */}
              {!selectedProject?.id ? (
                <Alert variant="warning" className="dh-alert dh-alert-warning text-center">
                  <FaBuilding className="me-2" />
                  No hay proyecto seleccionado. Por favor, seleccione un proyecto desde el menú principal.
                </Alert>
              ) : (
                <Card className="dh-card">
                  <Card.Header className="dh-card-header dh-card-header-primary">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        <FaCog className="me-2" />
                        Servicios de Comedores
                      </h5>
                      <div className="d-flex gap-2">
                        <Button
                          className="btn-dh-primary d-flex align-items-center"
                          onClick={() => handleShowModal()}
                          title="Agregar nuevo servicio"
                        >
                          <FaPlus className="me-2" size={14} />
                          Nuevo
                        </Button>
                        <Button
                          className="btn-dh-warning d-flex align-items-center"
                          onClick={() => {
                            if (state.registroSeleccionado) {
                              handleShowModal(state.registroSeleccionado);
                            } else {
                              toast.error("Seleccione un registro para editar", {
                                position: "bottom-right",
                                autoClose: 2000
                              });
                            }
                          }}
                          title="Editar servicio seleccionado"
                        >
                          <FaEdit className="me-2" size={14} />
                          Editar
                        </Button>
                        <Button
                          className="btn-dh-danger d-flex align-items-center"
                          onClick={() => handleDelete(state.registroSeleccionado?.id)}
                          title="Eliminar servicio seleccionado"
                        >
                          <FaTrash className="me-2" size={14} />
                          Eliminar
                        </Button>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body style={{ padding: '2rem' }}>
                    {/* Barra de búsqueda */}
                    <div className="mb-4">
                      <div className="position-relative" style={{ maxWidth: '500px' }}>
                        <Form.Control
                          type="text"
                          className="dh-form-control"
                          placeholder="Buscar servicio de comedor..."
                          value={state.searchTerm}
                          onChange={handleSearch}
                          style={{ paddingLeft: '3rem' }}
                        />
                        <FaSearch 
                          className="position-absolute" 
                          style={{ 
                            left: '1rem', 
                            top: '50%', 
                            transform: 'translateY(-50%)', 
                            color: '#6b7280' 
                          }} 
                        />
                      </div>
                    </div>

                    {/* Tabla de datos */}
                    {loadingTiposServicio ? (
                      <div className="text-center py-5">
                        <div className="dh-spinner"></div>
                        <p className="mt-3 text-muted">Cargando servicios de comedores...</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <Table className="dh-enhanced-table">
                          <thead>
                            <tr>
                              <th style={{ width: "50px" }}></th>
                              <th>ID</th>
                              <th>N° Orden</th>
                              <th>Proyecto</th>
                              <th>Cliente</th>
                              <th>Comedor</th>
                              <th>Tipo Servicio</th>
                              <th>Precio</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredRegistros.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center py-4">
                                  <div className="dh-alert dh-alert-info">
                                    <FaBuilding className="me-2" />
                                    No hay servicios registrados para este proyecto o no coinciden con la búsqueda
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              filteredRegistros.map((registro) => (
                                <tr 
                                  key={registro.id}
                                  className={state.registroSeleccionado?.id === registro.id ? 'selected' : ''}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleRegistroSelect(registro)}
                                >
                                  <td>
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={state.registroSeleccionado?.id === registro.id}
                                        onChange={() => {}}
                                      />
                                    </div>
                                  </td>
                                  <td style={{ fontWeight: '600', color: '#374151' }}>{registro.id}</td>
                                  <td style={{ fontWeight: '600', color: '#4f46e5' }}>
                                    {registro.numero_orden ?? 99}
                                  </td>
                                  <td>{registro.proyecto}</td>
                                  <td>{registro.cliente}</td>
                                  <td>{registro.comedor}</td>
                                  <td>{registro.tipo_servicio_alimentacion}</td>
                                  <td style={{ fontWeight: '600', color: '#059669' }}>S/ {registro.precio}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: '0.5rem 0.5rem 0 0'
        }}>
          <Modal.Title>
            <FaBuilding className="me-2" />
            {editRegistro ? "Editar" : "Nuevo"} Servicio de Comedor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '2rem' }}>
          {error && (
            <Alert variant="danger" className="dh-alert" style={{ 
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(248, 113, 113, 0.1) 100%)',
              color: '#dc2626',
              borderLeft: '4px solid #ef4444',
              borderRadius: '10px'
            }}>
              {error}
            </Alert>
          )}
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    Proyecto
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="dh-form-control"
                    value={selectedProject?.nombre || 'No hay proyecto seleccionado'}
                    disabled
                    readOnly
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    Cliente
                  </Form.Label>
                  <Form.Select 
                    name="id_cliente" 
                    value={form.id_cliente} 
                    onChange={handleChange} 
                    required
                    className="dh-form-control"
                  >
                    <option value="">-- Seleccione un cliente --</option>
                    {(() => {
                      console.log('Renderizando combo de clientes...');
                      console.log('clientesDelProyecto:', clientesDelProyecto);
                      console.log('Es array?:', Array.isArray(clientesDelProyecto));
                      console.log('Cantidad de clientes:', Array.isArray(clientesDelProyecto) ? clientesDelProyecto.length : 0);
                      
                      const clientes = Array.isArray(clientesDelProyecto) ? clientesDelProyecto : [];
                      return clientes.map((cliente) => {
                        console.log('Mapeando cliente:', cliente);
                        return (
                          <option key={cliente.id} value={cliente.id}>
                            {cliente.nombre}
                          </option>
                        );
                      });
                    })()}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    Comedor
                  </Form.Label>
                  <Form.Select 
                    name="id_comedor" 
                    value={form.id_comedor} 
                    onChange={handleChange} 
                    required
                    className="dh-form-control"
                  >
                    <option value="">-- Seleccione un comedor --</option>
                    {(Array.isArray(comedores) ? comedores : []).map((comedor) => (
                      <option key={comedor.id} value={comedor.id}>
                        {comedor.nombre}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    Tipo de Servicio de Alimentación
                  </Form.Label>
                  <Form.Select 
                    name="id_tipo_servicio_alimentacion" 
                    value={form.id_tipo_servicio_alimentacion} 
                    onChange={handleChange} 
                    required
                    className="dh-form-control"
                  >
                    <option value="">-- Seleccione tipo de servicio --</option>
                    {(Array.isArray(tipoServiciosAlimentacion) ? tipoServiciosAlimentacion : []).map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>
                        {tipo.descripcion}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    N° Orden
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="numero_orden"
                    value={form.numero_orden}
                    onChange={handleChange}
                    required
                    min="0"
                    step="1"
                    placeholder="1"
                    className="dh-form-control"
                  />
                  <Form.Text className="text-muted">
                    Menor número aparece primero en reportes.
                  </Form.Text>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: '600', color: '#374151' }}>
                    Precio (S/)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="precio"
                    value={form.precio}
                    onChange={handleChange}
                    required
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    className="dh-form-control"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ padding: '1.5rem 2rem', borderTop: '1px solid #e5e7eb' }}>
          <Button 
            className="btn-dh-secondary"
            onClick={handleCloseModal}
          >
            Cancelar
          </Button>
          <Button 
            className="btn-dh-primary"
            onClick={handleSave}
          >
            <FaUtensils className="me-2" size={14} />
            {editRegistro ? "Actualizar" : "Guardar"} Servicio
          </Button>
        </Modal.Footer>
      </Modal>

      <AntModal
        title={
          <span style={{ color: '#dc2626', fontWeight: '600' }}>
            <FaTrash className="me-2" />
            Confirmar Eliminación
          </span>
        }
        open={showDeleteModal}
        onOk={confirmDelete}
        onCancel={cancelDelete}
        okText="Eliminar"
        cancelText="Cancelar"
        okType="danger"
        centered
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
        cancelButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #6b7280 0%, #374151 100%)',
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
      >
        <div style={{ padding: '1rem 0' }}>
          <p style={{ color: '#374151', marginBottom: '0.5rem' }}>
            ¿Está seguro de que desea eliminar este servicio de comedor?
          </p>
          <p style={{ color: '#6b7280', marginBottom: '0', fontSize: '0.9rem' }}>
            Esta acción no se puede deshacer.
          </p>
        </div>
      </AntModal>
    </>
  );
};

export default GestionTipoServiciosComedor;
